/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-plusplus */
import React, { useState, useEffect } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import PropTypes from "prop-types";

const styles = {
  container: {
    my: 2,
    mr: 2,
    minWidth: 150,
    padding: 0,
    width: "100%",
  },
  selectOption: {
    "&.Mui-selected, &.Mui-selected:hover": {
      backgroundColor: "rgba(85, 108, 214, 0.4)",
    },
  },
};

function DropDownSelect({
  id,
  title,
  selectOptions,
  name,
  value,
  setValue,
  disabled,
  className,
  style,
  multiple,
}) {
  const [selectedItems, setSelectedItems] = useState(value);
  const [isCtrlPressed, setIsCtrlPressed] = useState(false);
  const [isShiftPressed, setIsShiftPressed] = useState(false);
  const [lastSelectedIndex, setLastSelectedIndex] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const [firstSelectedIndex, setFirstSelectedIndex] = useState(null);

  const handleKeyDown = (e) => {
    if (isFocused) {
      if (e.key === "Control") {
        setIsCtrlPressed(true);
      }
      if (e.key === "Shift") {
        setIsShiftPressed(true);
      }
    }
  };

  const handleKeyUp = (e) => {
    if (isFocused) {
      if (e.key === "Control") {
        setIsCtrlPressed(false);
      }
      if (e.key === "Shift") {
        setIsShiftPressed(false);
      }
    }
  };

  const handleSelection = (item, index) => {
    if (!selectedItems.includes(item)) {
      setSelectedItems((prev) => [...prev, item]);
      setValue((prev) => [...prev, item]);
    } else {
      setSelectedItems((prev) => prev.filter((value) => value !== item));
      setValue((prev) => prev.filter((value) => value !== item));
    }
  };

  const handleRangeSelection = (start, end) => {
    const range = selectOptions
      .slice(start, end + 1)
      .map((option) => option.value);
    const newSelectedItems = Array.from(new Set([...selectedItems, ...range]));
    setSelectedItems(newSelectedItems);
    setValue(newSelectedItems);
  };

  const handleSingleClick = (item, index) => {
    handleSelection(item, index);
    setFirstSelectedIndex((prev) => (prev === null ? index : prev));
    setLastSelectedIndex(index);
  };

  const handleClick = (item, index) => {
    if (isCtrlPressed && isShiftPressed && firstSelectedIndex !== null) {
      const start = Math.min(firstSelectedIndex, index);
      const end = Math.max(firstSelectedIndex, index);
      setFirstSelectedIndex((prev) => (prev === null ? index : prev));
      setLastSelectedIndex(index);
      handleRangeSelection(start, end);
    } else {
      handleSingleClick(item, index);
    }
  };

  const handleDeselection = (item, index) => {
    if (selectedItems.includes(item)) {
      setSelectedItems((prev) => prev.filter((value) => value !== item));
      setValue((prev) => prev.filter((value) => value !== item));
    }
  };

  useEffect(() => {
    const handleArrowKey = (e) => {
      if (isFocused && isShiftPressed && selectedItems.length > 0) {
        e.preventDefault();
        const currentIndex = selectOptions.findIndex(
          (option) => option.value === selectedItems[selectedItems.length - 1]
        );
        if (lastSelectedIndex > 0) {
          handleRangeSelection(firstSelectedIndex, lastSelectedIndex);
        }
        if (e.keyCode === 40) {
          // Down arrow key: select next item
          const nextIndex = Math.min(
            currentIndex + 1,
            selectOptions.length - 1
          );
          const selectedItem = selectOptions[nextIndex].value;
          handleSelection(selectedItem, nextIndex);
        } else if (e.keyCode === 38) {
          // Up arrow key: deselect previous item
          const nextIndex = Math.max(currentIndex - 1, 0);
          const deselectedItem = selectOptions[currentIndex].value;
          handleDeselection(deselectedItem, currentIndex);
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyUp);
    document.addEventListener("keydown", handleArrowKey);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handleKeyUp);
      document.removeEventListener("keydown", handleArrowKey);
    };
  }, [
    isShiftPressed,
    selectedItems,
    setValue,
    selectOptions,
    lastSelectedIndex,
    isFocused,
  ]);

  const handleChange = (event) => {
    const { value: selectedValue } = event.target;
    setSelectedItems(selectedValue);
    setValue(selectedValue);
    // setLastSelectedIndex(null);
    // setFirstSelectedIndex(null);
  };
  return (
    <FormControl
      sx={{ ...styles.container, ...style }}
      size="small"
      className={className}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
    >
      <InputLabel id={`${id}-label`}>{title}</InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        name={name}
        value={selectedItems}
        label={title}
        multiple={multiple}
        disabled={disabled}
        onChange={handleChange}
      >
        {selectOptions.map((option, index) => (
          <MenuItem
            sx={styles.selectOption}
            value={option.value}
            key={option.value}
            onClick={() => handleClick(option.value, index)}
          >
            {option.entityTitle}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

DropDownSelect.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  selectOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      entityTitle: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  setValue: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
};

DropDownSelect.defaultProps = {
  title: "",
  value: "",
  disabled: false,
  multiple: false,
  style: {},
  className: "",
};

export default DropDownSelect;
